var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-div textarea",style:({'minHeight': 12 + _vm.rows * 20 + 'px' }),attrs:{"contenteditable":_vm.canEdit},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"focus":function($event){_vm.isLocked = true;},"blur":_vm.changeText}})
}
var staticRenderFns = []

export { render, staticRenderFns }